module.exports = __webpack_public_path__ + "static/media/cultec_logo_bg.338f8f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/cultec_logo_bg.png
// module id = 2196
// module chunks = 0